// Get all monitor type list
export const GET_MONITOR_TYPE_LIST_REQUEST = "GET_MONITOR_TYPE_LIST_REQUEST"
export const GET_MONITOR_TYPE_LIST_SUCCESS = "GET_MONITOR_TYPE_LIST_SUCCESS"
export const GET_MONITOR_TYPE_LIST_FAIL = "GET_MONITOR_TYPE_LIST_FAIL"
